<div *ngIf="hideContent" class="container-fluid d-flex justify-content-center py-4 align-items-center"
  style="min-height: 60vh" dir="rtl">
  <p-progressSpinner ariaLabel="loading" />
</div>

<div class="p-10-px">
<div class="content-bg-2" [hidden]="hideContent">

  <div class="container-fluid">
    <div class="d-flex mt-2 justify-content-between flex-wrap">
      <div>
        <h4 class="color-grey">{{"General information about the "+from | translator}}</h4>
      </div>
      <div class="d-flex flex-wrap">
        <p-selectButton class="v4-active-2 mb-1 d-flex flex-wrap" *ngIf="assessmentIds.length > 1" [options]="filterOptions" [(ngModel)]="selectedFilterOptions"
          optionLabel="name" (ngModelChange)="getResults()" optionValue="value" />
      </div>
    </div>

    <div class="row justify-content-right">
      <ng-container *ngFor="let item of topStats">
        <!-- class="col-md-1 col-6 my-2" -->
        <div class="card-wraper p-0" *ngIf="!hideCards.includes(item.key) && isStatVisible(item)"
          [ngClass]="{ '': hasSubCards.includes(item.key) === true }" [id]="item.key">
          <div class="card assess-card w-100 h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4 11">
            <span class="{{item.value.icon}} " style="width: 2.5rem; height: 2.5rem;"></span>
            <hr class="hr w-75 border-4 color-grey" />
            <h6 class="card-text">{{item.key | translator}}</h6>
            <h3 class="card-heading">{{item.value.value}}</h3>
            <ng-container *ngIf="hasSubCards.includes(item.key) && false">
              <hr class="hr w-75 border-4 color-grey" />
              <div class="d-flex justify-content-center">
                <div *ngFor="let subItem of getSubCards(item.key) let i = index"
                  [ngClass]="{ 'border-right': i === 1 }">
                  <h6 class="card-text">{{subItem.key | translator}}</h6>
                  <h3 class=" card-heading">{{subItem.value.value}}</h3>
                </div>.
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <hr class="hr w-100 border-4 color-grey" />
  </div>


  <div class="container-fluid">
    <div class="row d-flex align-items-center">
      <div class="col-md-5 col-12">
        <div class="row row-cols-2">
          <div class="col-md-12 col-12 p-2" *ngFor="let criteria of criterias">
            <div class="card assess-card">
              <table class="table">
                <thead>
                  <tr *ngIf="criterias.length == 1;">
                    <th colspan="3">{{ 'Result Grades' | translator }}</th>
                  </tr>
                  <tr *ngIf="criterias.length != 1;">
                    <th colspan="3">{{ criteria._id }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of criteria.data">
                    <td><i class="{{ item.icon }}"></i></td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.from }} - {{ item.to }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="cc">
          <p-chart type="pie" [data]="totalGradesData" [options]="options" height="400"></p-chart>
        </div>
      </div>

      <div class="col-md-4 col-12 tab-center">
        <div class="tooltips-container w-100 d-flex gap-3 mt-2 flex-wrap">
          <div class="tooltip-item p-2" *ngFor="let label of totalGradesData?.labels; let i = index">
            <table dir="rtl" style="background: white; color: black">
              <thead>
                <tr>
                  <th>
                    <span>{{label}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  [style.background]="
                totalGradesData?.datasets[0]?.backgroundColor?.[i] 
                  ? totalGradesData.datasets[0].backgroundColor[i] 
                  : totalGradesData.datasets[0].backgroundColor[i % totalGradesData.datasets[0].backgroundColor.length]"
                  style="border: 2px solid white ;color: white; text-align: center; width: 100%;">
                  <td style="padding: 5px 10px">
                    <span>{{totalGradesData?.datasets[0]?.data[i]}} مختبر</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <hr class="hr w-100 border-4 color-grey" />
  </div>


  <div class="container-fluid">
    <h4 *ngIf="alldata && alldata['Overall average for the assessment in percentage']" class="color-grey">
      {{
      "Overall average heading"
      | translator
      }}
    </h4>
    <div class="row justify-content-right">
      <div class="card-wraper p-0">
        <div class="card assess-card w-100 h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4 22">
          <span class="{{ getIcon('Overall average for the assessment in percentage') }} "
            style="width: 2.5rem; height: 2.5rem"></span>
          <h6 class="card-text">{{ 'Total Grades out of 100' | translator }}</h6>
          <hr class="hr w-75 border-4 color-grey" />
          <h6 class="card-text">{{'Overall average for the assessment in percentage' | translator}}
          </h6>
          <h3 class="card-heading">
            {{
            alldata?.['Overall average for the assessment in percentage']
            ? formatScore(alldata['Overall average for the assessment in percentage'].value)
            : 'N/A'
            }}%
          </h3>
        </div>
      </div>

      <div class="card-wraper p-0">
        <div class="card assess-card w-100 h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4 33">
          <span class="{{ getIcon('Overall average for the assessment in marks') }} "
            style="width: 2.5rem; height: 2.5rem"></span>
          <h6 class="card-text">{{ ('Total Marks out of' | translator) + ' ' + (alldata?.['Total Marks'] ? formatScore(alldata['Total
            Marks'].value) : 'N/A') }}</h6>
          <hr class="hr w-75 border-4 color-grey" />
          <h6 class="card-text">{{'Overall average for the assessment in marks' | translator}}</h6>
          <h3 class="card-heading">
            {{
            alldata?.['Overall average for the assessment in marks']
            ? formatScore(alldata['Overall average for the assessment in marks'].value)
            : 'N/A'
            }}
          </h3>

        </div>
      </div>

      <div class="card-wraper p-0">
        <div class="card assess-card w-100 h-100 d-flex flex-column justify-content-center align-items-center px-2 py-4 44">
          <span class="{{ getIcon('Overall average for the assessment in grades') }} "
            style="width: 2.5rem; height: 2.5rem;"></span>
          <h6 class="card-text">{{ "Appreciation" | translator }}</h6>
          <hr class="hr w-75 border-4 color-grey" />
          <h6 class="card-text">{{'Overall average for the assessment in grades' | translator}}</h6>
          <h3 class="card-heading">
            {{
            alldata?.['Overall average for the assessment in grades']
            ? alldata['Overall average for the assessment in grades'].value
            : 'N/A'
            }}
          </h3>

        </div>
      </div>


    </div>

    <hr class="hr w-100 border-4 color-grey " />
  </div>




  <div class="container-fluid" *ngIf="alldata?.domainAnswers?.length > 0">

    <h4 class="color-grey">
      {{
      "Correct answers according to topics"
      | translator
      }}
    </h4>

    <div class="row justify-content-right">

      <div *ngFor="let graph of alldata.domainAnswers; let j = index" class="col-12 col-md-3 g-2">

        <div class="card assess-card w-100 h-100 d-flex flex-column p-4 text-center">
          <div class="pb-3" *ngIf="graph._id">
            <h5 pTooltip="{{ graph._id | translator }}" class="graph-heading">

              <span *ngIf="graph._id.parentId">{{graph._id.parentId}} > </span>
              {{ graph._id.label ? graph._id.label : graph._id | translator }}

            </h5>
          </div>


          <div>
            <p-chart type="pie" [data]="{
              'labels': graph.labels,
              'datasets': graph.datasets
            }" [options]="options2" height="300" width="250"></p-chart>
          </div>
        </div>

      </div>
    </div>


    <hr class="hr w-100 border-4 color-grey " />
  </div>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 col-12 mb-3">
      <div class="d-flex gap-2 align-items-center">
        <label for="worstPerformingPercentage" class="form-label mb-0 card-text">
          {{ "Worst Performing Question Percentage" | translator }}:
        </label>
        <input 
          id="worstPerformingPercentage"
          type="number" 
          [(ngModel)]="worstPerformingQuestionPercentageInput" 
          (keyup.enter)="getResults()"
          class="form-control"
          style="width: 150px;"
          step="1"
          min="1"
          max="100"
          placeholder="69"
        />
        <span class="form-text">%</span>
        <button 
          (click)="getResults()"
          class="btn btn-primary"
          type="button"
        >
          {{ "Apply" | translator }}
        </button>
      </div>
    </div>
    
  <div *ngIf="worstPerformingQuestions?.length > 0" class="col-md-12 col-12">

    <div class="row pt-2">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center 11">
          <span class="icon-svg icon-svg-128" style="width: 2.5rem; height: 2.5rem"></span>
          <h1 class="card-heading">

            <!-- <span *ngIf="j == 0">*</span> --> {{ question.count - question.correct }}

          </h1>
          <b class="text-primary">{{ "from" | translator }} {{ question.count }}
            {{ "Assessment Attendees" | translator }}</b>
          <hr class="hr w-75 border-4 color-grey" />

          <p class="card-text">

            {{ "They got the question wrong" | translator}}
            <b>({{ cleanQuestionText(question.data.questionText) }})</b>
            {{"That is of all" |translator }} <b>{{ calculatePercentage(question)}}%</b> {{"of all the test takers" |
            translator}}
          </p>


        </div>
      </div>
    </div>

    <div class="row pt-1">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center 22">

          <div *ngFor="let option of question.data.meta.fields; let i = index">
            <p class="card-text" *ngIf="question.data.meta.correct === option.label">
              <b>{{ "the correct answer" | translator}}:</b> <span> {{ option.label }}</span>
            </p>
          </div>

        </div>
      </div>
    </div>

    <div class="row pt-1" *ngIf="worstPerformingQuestions[0].data.meta.selectedTopic">
      <div *ngFor="let question of worstPerformingQuestions; let j = index" class="col">
        <div
          class="card assess-card w-100 h-100 d-flex flex-column align-items-center justify-content-start p-4 text-center 33">
          
          <h5 class="card-text">{{ question.data.meta.selectedTopic.label }}</h5>
        </div>
      </div>
    </div>
    <hr class="hr w-100 border-4 color-grey" />
    </div>
    </div>
</div>

  <div class="d-flex gap-2 flex-wrap">
    <button *ngIf="!downloadCWExcel && assessmentIds.length > 1" style="background-color: #217346;"
      class="my-3-web py-2 v4-btn-every" (click)="exportCorrectWrongExcel()">
      {{ 'correct incorrect stats' | translator }} <i class="fa-regular fa-file-excel"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadExcel && assessmentIds.length > 1" style="background-color: #217346;"
      class="my-3-web py-2 v4-btn-every" (click)="exportExcel()">
      {{ 'Download Excel' | translator }} <i class="fa-regular fa-file-excel"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadPdf && assessmentIds.length > 1" style="background-color: grey;"
      class="my-3-web py-2 v4-btn-every" (click)="exportPdf()">
      {{ 'Download PDF' | translator }} <i class="fa-regular fa-file-pdf"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>

    <button *ngIf="!downloadPowerPoint && assessmentIds.length > 1" style="background-color: #217346;"
      class="my-3-web py-2 v4-btn-every" (click)="exportToPPT()">
      {{ 'Download Powerpoint' | translator }} <i class="fa-regular fa-file-powerpoint"></i>
    </button>
    <p-progressSpinner class="v4-spin" *ngIf="downloadPowerPoint" ariaLabel="loading"></p-progressSpinner>


    <!-- Hiding this -->
    <button *ngIf="alldata && alldata?.listOfMuliTakers?.length > 0 && false" style="background-color: #217346;"
      class="my-3-web py-2 v4-btn-every" (click)="exportToPPTForMultitakers()">
      {{ "the list of users who have attempted multiple times" | translator }}<i
        class="fa-regular fa-file-powerpoint"></i>
    </button>

  </div>


  <div *ngIf="alldata && alldata?.listOfMuliTakers?.length > 0 && false" class="">

    <div class="d-flex flex-wrap align-items-center justify-content-between mb-2 gap-2">
      <h4 class="color-grey m-0">
        {{ "the list of users who have attempted multiple times" | translator}}
      </h4>
      <div class="d-flex align-items-center gap-2">
        <i class="pi pi-search color-grey"></i>
        <input pInputText type="text" class="p-inputtext-sm" [placeholder]="'Search...' | translator"
               [(ngModel)]="multiTakersSearchTerm" (ngModelChange)="onMultiTakersSearchChange($event)" />
      </div>
    </div>
    <table class="custom-table pt-1">
      <thead>
        <tr>
          <th>{{"Email" | translator}}</th>
          <th>{{"Name" | translator}}</th>
          <th>{{"number of times" | translator}}</th>
          <th>{{"Assessments" | translator}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rowData of multiTakersPageData">
          <td>{{ rowData._id }}</td>
          <td>{{ rowData.name }}</td>
          <td>{{ rowData.sum }}</td>
          <td>
            <ul>
              <li *ngFor="let assessment of rowData.assessments">{{ assessment }}</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <p-paginator
      [rows]="multiTakersRows"
      [totalRecords]="multiTakersFilteredData.length || alldata?.listOfMuliTakers?.length || 0"
      [first]="multiTakersPage * multiTakersRows"
      [rowsPerPageOptions]="[5,10,20,50]"
      (onPageChange)="updateMultiTakersPage($event)"
      class="mt-2"
    ></p-paginator>
    <!-- <hr class="hr w-100 border-4 color-grey" /> -->
  </div>

</div>
</div>